import styled from 'styled-components'
import { fonts, colors, sizes, breakpoints } from '../../css-variables'

export default styled.div`
    position: relative;
    font-family: ${fonts.redHatText};
    border-top: 2px solid ${colors.bgActiveGrey};
    border-bottom: 2px solid ${colors.bgActiveGrey};

    h4 {
        font-family: ${fonts.redHatDisplay};
        font-weight: bold;
        font-size: ${sizes.s16};
        text-transform: uppercase;
        padding: ${sizes.s16} 0;
    }

    @media screen and ${breakpoints.tabletS} {
        width: 100%;
        max-width: 536px;
        padding-left: 0;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
    }

    @media screen and ${breakpoints.laptopS} {
        margin-left: 0;
        max-width: 712px;
        margin-bottom: 0 !important;
        border: none;
        margin-top: 7px; // hack to get menu title & page title vertically aligned (curse you, Mrs. Eaves!)
        padding: 0;

        h4 {
            text-transform: uppercase;
            font-size: ${sizes.s18};
            padding: 0 0 ${sizes.s24};
        }
    }

    ul {
        justify-self: left;
        margin-left: 0;
        margin-right: ${sizes.s18};
    }

    li {
        list-style: none;
        margin: 0;
        padding-top: 4px;
        padding-bottom: 4px;
        a {
            text-decoration: none;
            color: ${colors.navMenuBlack};
            font-size: 16px;
            padding-top: 4px;
            padding-bottom: 4px;
            display: block;
            &:hover {
                color: ${colors.linkTextHover};
            }
            &.active {
                font-weight: 500;
            }
        }
        li {
            margin-left: 16px;
        }
    }
`
